import React, { useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'

import Avatar from './Avatar'
import MotivationalQuotes from './MotivationalQuotes'
import IdentityInfo from './IdentityInfo'
import PasswordChange from './PasswordChange'

const Profile = () => {
  const [tab, setTab] = useState(0)

  const tabs = [
    {
      label: 'My info',
      Component: IdentityInfo,
    },
    {
      label: 'Avatar',
      Component: Avatar,
    },
    {
      label: 'Motivational Quotes',
      Component: MotivationalQuotes,
    },
    {
      label: 'Change Password',
      Component: PasswordChange,
    },
  ]

  const { Component } = tabs[tab]

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Tabs onChange={(e, val) => setTab(val)} value={tab} centered>
          {tabs.map((t) => (
            <Tab key={t.label} label={t.label} />
          ))}
        </Tabs>
      </Box>

      <Component />
    </>
  )
}

export default Profile
